'use client';

import React, { ReactNode } from 'react';

import {
    Align,
    Box,
    BoxContent,
    DirectionEnum,
    FlexBox,
    FlexItem,
    GapSize,
    Icon,
    IconColor,
    IconName,
    IconSize,
    Image,
    Row,
    Rows,
    Text,
    TextLevels,
    Title,
    TitleLevels,
    TrilogyColor,
} from '@bytel/trilogy-react';

interface ComparatorProps {
    className?: string;
    name?: string;
    children: ReactNode;
}

export function Comparator({ className = '', children }: Readonly<ComparatorProps>) {
    return (
        <Rows gap={GapSize.SEVEN} className={className}>
            {children}
        </Rows>
    );
}
export function ComparatorRows({ className = '', children }: Readonly<ComparatorProps>) {
    return (
        <Row>
            <Rows gap={GapSize.THREE} className={className}>
                {children}
            </Rows>
        </Row>
    );
}

export function ComparatorColumns({ className = '', children }: Readonly<ComparatorProps>) {
    return (
        <FlexBox gap={GapSize.THREE} direction={DirectionEnum.ROW} className={className}>
            {children}
        </FlexBox>
    );
}

export function ComparatorColumn({ className = '', children }: Readonly<ComparatorProps>) {
    return (
        <FlexItem size={{ tablet: 4 }} className={className}>
            {children}
        </FlexItem>
    );
}

export function ComparatorRowHead({ label, imageUrl }: Readonly<{ label: ReactNode; imageUrl?: string }>) {
    return (
        <Row>
            <FlexBox align={Align.CENTER}>
                {imageUrl && <Image src={imageUrl} height='20px' alt='' />}
                <Title level={TitleLevels.FIVE}>{label}</Title>
            </FlexBox>
        </Row>
    );
}
export function ComparatorRowSubHead({ label }: Readonly<{ label: string }>) {
    return (
        <Row>
            <Text level={TextLevels.TWO}>{label}</Text>
        </Row>
    );
}

export function ComparatorRow({ className = '', children, name }: Readonly<ComparatorProps>) {
    return (
        <Row>
            <Text marginless>{name}</Text>
            <ComparatorColumns className={className}>{children}</ComparatorColumns>
        </Row>
    );
}

export function ComparatorCell({
    className = '',
    children = <Icon name={IconName.TIMES} color={IconColor.GREY} size={IconSize.SMALL} className='m-auto' />,
}: Readonly<ComparatorProps>) {
    return (
        <ComparatorColumn>
            <Box backgroundColor={TrilogyColor.NEUTRAL_FADE} shadowless className='is-fullheight'>
                <BoxContent className={className}>{children}</BoxContent>
            </Box>
        </ComparatorColumn>
    );
}
